import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import {
    Router,
    NavigationStart,
    NavigationCancel,
    NavigationEnd,
} from "@angular/router";
import {
    Location,
    LocationStrategy,
    PathLocationStrategy,
} from "@angular/common";
import { filter } from "rxjs/operators";
import { LoginService } from "./services/login.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
declare let $: any;

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
    ],
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;
    private destroyRef = inject(DestroyRef);

    constructor(
        private router: Router,
        private loginService: LoginService,
    ) {}

    ngOnInit() {
        this.loginService.registerHandlers(true);
        this.recallJsFuntions();
    }

    recallJsFuntions() {
        this.router.events
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    $(".preloader").fadeIn("slow");
                }
            });
        this.routerSubscription = this.router.events
            .pipe(
                filter(
                    (event) =>
                        event instanceof NavigationEnd ||
                        event instanceof NavigationCancel,
                ),
            )
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
                $.getScript("../assets/js/main.js");
                $(".preloader").fadeOut("slow");
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }
}
